import React from 'react';
import LateralMenu from '../LateralMenu';
import { faFileSignature } from '@fortawesome/free-solid-svg-icons';
import { translate } from '../../services/translate';
import logo from '../../../assets/logo_signatures.png';
import collapsedLogo from '../../../assets/icon_crm.png';

export default function SignaturesLateralMenu({
    navigation,
    open,
    authenticatedUser,
    setOpen,
    selectedMenu,
}: LateralMenuProps) {
    const items = [];

    items.push({
        icon: faFileSignature,
        text: translate('signatures'),
        action: () => navigation.navigate('Signatures', { screen: 'Signatures' }),
        selected: selectedMenu == 'signatures',
    });

    return (
        <LateralMenu
            topImage={logo}
            collapsedTopImage={collapsedLogo}
            open={open}
            setOpen={setOpen}
            authenticatedUser={authenticatedUser}
            items={items}
        />
    );
}
